import {useState} from "../../__snowpack__/pkg/react.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
import qs from "../../__snowpack__/pkg/qs.js";
export const useCustomerManagement = () => {
  const [customerList, setCustomerList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    size: 20,
    total: 0,
    totalPages: 0
  });
  const fetchData = async (pageInfo2, search) => {
    setIsLoading(true);
    pageInfo2.page = pageInfo2.page >= 1 ? pageInfo2.page - 1 : 0;
    try {
      const {
        data: {content, number, totalElements, size, totalPages}
      } = await axios.post(`/saas/product/v1/customers/search?${qs.stringify(pageInfo2)}`, search);
      setCustomerList(content || []);
      const page = {
        page: number + 1 || 1,
        size: size || 50,
        total: totalElements,
        totalPages: totalPages || 0
      };
      setPageInfo(page);
      return {list: content, pageInfo: page};
    } catch (e) {
      setIsLoading(false);
      handleError(e);
      return {list: customerList, pageInfo: pageInfo2};
    } finally {
      setIsLoading(false);
    }
  };
  return {
    customerList,
    fetchCustomers: fetchData,
    pageInfo,
    isLoading
  };
};
export default useCustomerManagement;
